import type { i18n as I18nInstance } from 'i18next';

import { waitForI18nInit } from './i18n';
import { isOtaConfigured } from './phraseOta';

export { isOtaConfigured as isPhraseConfigured };

export async function setLanguage(lang: string, i18n: I18nInstance): Promise<void> {
  await waitForI18nInit();
  await i18n.changeLanguage(lang);
}
